// extracted by mini-css-extract-plugin
export default {"main":"Checkbox_main__0tV3p","container":"Checkbox_container__WX6Z3","dot":"Checkbox_dot__iAdaf","text":"Checkbox_text__vYVX9"};